import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, CircularProgress } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

const DeletePopUp = ({modal, title, content, toggleModalFn, deleteRecordFn, confirmText, cancelText, cancelColor, confirmColor,loader}) => {
  return(
    <Dialog
      open={modal}
      onClose={toggleModalFn}
      aria-labelledby="scroll-dialog-title"
    >
      <DialogTitle id="scroll-dialog-title">
        { title ? title:'Delete'}
      </DialogTitle>
      <DialogContent dividers={true}>
        <div className="delete-record-modal" style={isMobile ? {width:'auto'}:{minWidth:'400px'}}>
          <div className="">
            {content}
          </div>
          <div className="actions-cta">
            <Button className='mr-5' variant="outlined" size='small' onClick={toggleModalFn} color={cancelColor ? cancelColor : 'primary'}>{cancelText ? cancelText :'Cancel'}</Button>
            <Button variant="contained" size='small' onClick={deleteRecordFn} color={confirmColor ? confirmColor : "secondary"}>{confirmText ? confirmText: loader ? <CircularProgress color="#ffffff" size={24} /> : 'Delete' }</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DeletePopUp;
